@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(648_846_866)
public val Res.string.labour_budget_open_unpriced: StringResource by lazy {
      StringResource("string:labour_budget_open_unpriced", "labour_budget_open_unpriced", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 173133, 195),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 245601, 247),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157220, 163),
      ))
    }

@delegate:ResourceContentHash(1_302_576_191)
public val Res.string.labour_budget_over: StringResource by lazy {
      StringResource("string:labour_budget_over", "labour_budget_over", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 173329, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 245849, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157384, 50),
      ))
    }

@delegate:ResourceContentHash(2_005_425_973)
public val Res.string.labour_budget_planned: StringResource by lazy {
      StringResource("string:labour_budget_planned", "labour_budget_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 173380, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 245916, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157435, 41),
      ))
    }

@delegate:ResourceContentHash(1_344_037_879)
public val Res.string.labour_budget_used: StringResource by lazy {
      StringResource("string:labour_budget_used", "labour_budget_used", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 173418, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 245958, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157477, 42),
      ))
    }

@delegate:ResourceContentHash(-1_631_648_720)
public val Res.string.labour_budget_week: StringResource by lazy {
      StringResource("string:labour_budget_week", "labour_budget_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 173461, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 246001, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157520, 62),
      ))
    }

@delegate:ResourceContentHash(2_054_778_241)
public val Res.string.labour_cost_export: StringResource by lazy {
      StringResource("string:labour_cost_export", "labour_cost_export", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 173623, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 246203, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157674, 78),
      ))
    }

@delegate:ResourceContentHash(-55_919_274)
public val Res.string.labour_cost_exported: StringResource by lazy {
      StringResource("string:labour_cost_exported", "labour_cost_exported", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 173566, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 246134, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157625, 48),
      ))
    }

@delegate:ResourceContentHash(-276_208_034)
public val Res.string.labour_warning_daily_norm: StringResource by lazy {
      StringResource("string:labour_warning_daily_norm", "labour_warning_daily_norm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 173702, 93),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 246310, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157753, 97),
      ))
    }

@delegate:ResourceContentHash(-1_149_716_294)
public val Res.string.labour_warning_daily_rest: StringResource by lazy {
      StringResource("string:labour_warning_daily_rest", "labour_warning_daily_rest", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 173796, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 246428, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157851, 109),
      ))
    }

@delegate:ResourceContentHash(1_202_556_932)
public val Res.string.labour_warning_overtime: StringResource by lazy {
      StringResource("string:labour_warning_overtime", "labour_warning_overtime", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 173914, 143),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 246594, 247),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157961, 143),
      ))
    }

@delegate:ResourceContentHash(1_039_983_885)
public val Res.string.labour_warning_weekly_average: StringResource by lazy {
      StringResource("string:labour_warning_weekly_average", "labour_warning_weekly_average", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 174058, 121),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 246842, 189),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158105, 105),
      ))
    }

@delegate:ResourceContentHash(-531_629_561)
public val Res.string.labour_warning_weekly_rest: StringResource by lazy {
      StringResource("string:labour_warning_weekly_rest", "labour_warning_weekly_rest", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 174180, 134),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 247032, 206),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158211, 130),
      ))
    }

@delegate:ResourceContentHash(869_756_665)
public val Res.string.language_change: StringResource by lazy {
      StringResource("string:language_change", "language_change", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 174315, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 247239, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158342, 51),
      ))
    }

@delegate:ResourceContentHash(-1_666_405_553)
public val Res.string.language_device: StringResource by lazy {
      StringResource("string:language_device", "language_device", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 174435, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 247379, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158458, 43),
      ))
    }

@delegate:ResourceContentHash(221_701_709)
public val Res.string.language_device_current: StringResource by lazy {
      StringResource("string:language_device_current", "language_device_current", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 174367, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 247303, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158394, 63),
      ))
    }

@delegate:ResourceContentHash(1_574_080_816)
public val Res.string.language_hint: StringResource by lazy {
      StringResource("string:language_hint", "language_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 174483, 145),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 247439, 233),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158502, 141),
      ))
    }

@delegate:ResourceContentHash(1_573_343_825)
public val Res.string.language_name_en: StringResource by lazy {
      StringResource("string:language_name_en", "language_name_en", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 174629, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 247673, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158644, 36),
      ))
    }

@delegate:ResourceContentHash(-126_813_321)
public val Res.string.language_name_pl: StringResource by lazy {
      StringResource("string:language_name_pl", "language_name_pl", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 174666, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 247710, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158681, 32),
      ))
    }

@delegate:ResourceContentHash(-895_163_964)
public val Res.string.language_name_uk: StringResource by lazy {
      StringResource("string:language_name_uk", "language_name_uk", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 174699, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 247743, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158714, 52),
      ))
    }

@delegate:ResourceContentHash(370_518_822)
public val Res.string.language_title: StringResource by lazy {
      StringResource("string:language_title", "language_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 174752, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 247796, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158767, 34),
      ))
    }

@delegate:ResourceContentHash(832_601_499)
public val Res.string.leave_allowance_carry_over: StringResource by lazy {
      StringResource("string:leave_allowance_carry_over", "leave_allowance_carry_over", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 174783, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 247831, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158802, 82),
      ))
    }

@delegate:ResourceContentHash(-2_062_423_721)
public val Res.string.leave_allowance_entitlement: StringResource by lazy {
      StringResource("string:leave_allowance_entitlement", "leave_allowance_entitlement", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175004, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 248156, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159051, 59),
      ))
    }

@delegate:ResourceContentHash(787_220_450)
public val Res.string.leave_allowance_entitlement_hint: StringResource by lazy {
      StringResource("string:leave_allowance_entitlement_hint", "leave_allowance_entitlement_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 174935, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 248051, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158966, 84),
      ))
    }

@delegate:ResourceContentHash(2_099_748_350)
public val Res.string.leave_allowance_entitlement_hint_unknown: StringResource by lazy {
      StringResource("string:leave_allowance_entitlement_hint_unknown", "leave_allowance_entitlement_hint_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 174866, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 247946, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158885, 80),
      ))
    }

@delegate:ResourceContentHash(733_676_052)
public val Res.string.leave_allowance_invalid: StringResource by lazy {
      StringResource("string:leave_allowance_invalid", "leave_allowance_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175056, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 248220, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159111, 75),
      ))
    }

@delegate:ResourceContentHash(-175_803_933)
public val Res.string.leave_allowance_saved: StringResource by lazy {
      StringResource("string:leave_allowance_saved", "leave_allowance_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175128, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 248312, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159187, 45),
      ))
    }

@delegate:ResourceContentHash(-944_756_631)
public val Res.string.leave_allowance_title: StringResource by lazy {
      StringResource("string:leave_allowance_title", "leave_allowance_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175178, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 248394, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159233, 49),
      ))
    }

@delegate:ResourceContentHash(-217_017_510)
public val Res.string.leave_balance_carry_over: StringResource by lazy {
      StringResource("string:leave_balance_carry_over", "leave_balance_carry_over", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175224, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 248456, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159283, 68),
      ))
    }

@delegate:ResourceContentHash(-1_834_142_416)
public val Res.string.leave_balance_entitlement: StringResource by lazy {
      StringResource("string:leave_balance_entitlement", "leave_balance_entitlement", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175383, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 248671, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159430, 61),
      ))
    }

@delegate:ResourceContentHash(-2_008_456_173)
public val Res.string.leave_balance_entitlement_set: StringResource by lazy {
      StringResource("string:leave_balance_entitlement_set", "leave_balance_entitlement_set", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175297, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 248557, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159352, 77),
      ))
    }

@delegate:ResourceContentHash(-394_438_812)
public val Res.string.leave_balance_left: StringResource by lazy {
      StringResource("string:leave_balance_left", "leave_balance_left", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175441, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 248745, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159492, 58),
      ))
    }

@delegate:ResourceContentHash(1_226_860_742)
public val Res.string.leave_balance_on_demand: StringResource by lazy {
      StringResource("string:leave_balance_on_demand", "leave_balance_on_demand", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175504, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 248832, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159551, 71),
      ))
    }

@delegate:ResourceContentHash(-2_122_656_181)
public val Res.string.leave_balance_pending: StringResource by lazy {
      StringResource("string:leave_balance_pending", "leave_balance_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175588, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 248936, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159623, 61),
      ))
    }

@delegate:ResourceContentHash(-1_059_276_932)
public val Res.string.leave_balance_title: StringResource by lazy {
      StringResource("string:leave_balance_title", "leave_balance_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175642, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 249010, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159685, 51),
      ))
    }

@delegate:ResourceContentHash(1_232_911_097)
public val Res.string.leave_balance_unknown: StringResource by lazy {
      StringResource("string:leave_balance_unknown", "leave_balance_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175702, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 249090, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159737, 57),
      ))
    }

@delegate:ResourceContentHash(1_804_771_806)
public val Res.string.leave_balance_used: StringResource by lazy {
      StringResource("string:leave_balance_used", "leave_balance_used", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175756, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 249172, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159795, 34),
      ))
    }

@delegate:ResourceContentHash(-144_216_733)
public val Res.string.leave_balances_edit: StringResource by lazy {
      StringResource("string:leave_balances_edit", "leave_balances_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175799, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 249231, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159830, 43),
      ))
    }

@delegate:ResourceContentHash(1_828_970_960)
public val Res.string.leave_balances_empty: StringResource by lazy {
      StringResource("string:leave_balances_empty", "leave_balances_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175843, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 249303, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159874, 60),
      ))
    }

@delegate:ResourceContentHash(500_133_261)
public val Res.string.leave_balances_export: StringResource by lazy {
      StringResource("string:leave_balances_export", "leave_balances_export", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175972, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 249460, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159987, 45),
      ))
    }

@delegate:ResourceContentHash(-55_919_274)
public val Res.string.leave_balances_exported: StringResource by lazy {
      StringResource("string:leave_balances_exported", "leave_balances_exported", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 175912, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 249388, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159935, 51),
      ))
    }

@delegate:ResourceContentHash(78_388_558)
public val Res.string.leave_balances_open: StringResource by lazy {
      StringResource("string:leave_balances_open", "leave_balances_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176022, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 249514, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160033, 47),
      ))
    }

@delegate:ResourceContentHash(78_388_558)
public val Res.string.leave_balances_title: StringResource by lazy {
      StringResource("string:leave_balances_title", "leave_balances_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176070, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 249586, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160081, 48),
      ))
    }

@delegate:ResourceContentHash(-2_021_965_204)
public val Res.string.leave_csv_carry_over: StringResource by lazy {
      StringResource("string:leave_csv_carry_over", "leave_csv_carry_over", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176119, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 249659, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160130, 44),
      ))
    }

@delegate:ResourceContentHash(-48_346_779)
public val Res.string.leave_csv_entitlement: StringResource by lazy {
      StringResource("string:leave_csv_entitlement", "leave_csv_entitlement", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176160, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 249716, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160175, 45),
      ))
    }

@delegate:ResourceContentHash(-1_457_385_929)
public val Res.string.leave_csv_on_demand_limit: StringResource by lazy {
      StringResource("string:leave_csv_on_demand_limit", "leave_csv_on_demand_limit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176198, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 249762, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160221, 53),
      ))
    }

@delegate:ResourceContentHash(-1_981_360_377)
public val Res.string.leave_csv_on_demand_used: StringResource by lazy {
      StringResource("string:leave_csv_on_demand_used", "leave_csv_on_demand_used", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176264, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 249840, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160275, 52),
      ))
    }

@delegate:ResourceContentHash(-1_786_834_653)
public val Res.string.leave_csv_pending: StringResource by lazy {
      StringResource("string:leave_csv_pending", "leave_csv_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176337, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 249933, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160328, 37),
      ))
    }

@delegate:ResourceContentHash(2_124_741_052)
public val Res.string.leave_csv_remaining: StringResource by lazy {
      StringResource("string:leave_csv_remaining", "leave_csv_remaining", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176379, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 249975, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160366, 35),
      ))
    }

@delegate:ResourceContentHash(-1_641_193_974)
public val Res.string.leave_csv_total: StringResource by lazy {
      StringResource("string:leave_csv_total", "leave_csv_total", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176423, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 250023, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160402, 31),
      ))
    }

@delegate:ResourceContentHash(1_804_709_341)
public val Res.string.leave_csv_used: StringResource by lazy {
      StringResource("string:leave_csv_used", "leave_csv_used", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176455, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 250063, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160434, 30),
      ))
    }

@delegate:ResourceContentHash(1_386_119_363)
public val Res.string.leave_csv_year: StringResource by lazy {
      StringResource("string:leave_csv_year", "leave_csv_year", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176494, 26),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 250118, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160465, 30),
      ))
    }

@delegate:ResourceContentHash(352_289_629)
public val Res.string.leave_request_days: StringResource by lazy {
      StringResource("string:leave_request_days", "leave_request_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176521, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 250149, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160496, 74),
      ))
    }

@delegate:ResourceContentHash(1_206_717_624)
public val Res.string.leave_request_exceeds: StringResource by lazy {
      StringResource("string:leave_request_exceeds", "leave_request_exceeds", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176700, 141),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 250412, 225),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160671, 133),
      ))
    }

@delegate:ResourceContentHash(-721_718_748)
public val Res.string.leave_request_exceeds_on_demand: StringResource by lazy {
      StringResource("string:leave_request_exceeds_on_demand", "leave_request_exceeds_on_demand", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176588, 111),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 250236, 175),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160571, 99),
      ))
    }

@delegate:ResourceContentHash(-1_597_704_741)
public val Res.string.ledger_kind_cost: StringResource by lazy {
      StringResource("string:ledger_kind_cost", "ledger_kind_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176842, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 250638, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160805, 32),
      ))
    }

@delegate:ResourceContentHash(867_893_484)
public val Res.string.ledger_kind_label: StringResource by lazy {
      StringResource("string:ledger_kind_label", "ledger_kind_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176875, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 250683, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160838, 33),
      ))
    }

@delegate:ResourceContentHash(-1_568_102_855)
public val Res.string.ledger_kind_revenue: StringResource by lazy {
      StringResource("string:ledger_kind_revenue", "ledger_kind_revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176909, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 250717, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160872, 39),
      ))
    }

@delegate:ResourceContentHash(-1_630_197_841)
public val Res.string.legal_dpa_note: StringResource by lazy {
      StringResource("string:legal_dpa_note", "legal_dpa_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 176949, 198),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 250761, 314),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160912, 190),
      ))
    }

@delegate:ResourceContentHash(-1_293_199_518)
public val Res.string.legal_privacy: StringResource by lazy {
      StringResource("string:legal_privacy", "legal_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 177218, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 251146, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161169, 41),
      ))
    }

@delegate:ResourceContentHash(-1_255_315_517)
public val Res.string.legal_privacy_url: StringResource by lazy {
      StringResource("string:legal_privacy_url", "legal_privacy_url", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 177148, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 251076, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161103, 65),
      ))
    }

@delegate:ResourceContentHash(-483_939_703)
public val Res.string.legal_signup_note: StringResource by lazy {
      StringResource("string:legal_signup_note", "legal_signup_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 177268, 157),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 251236, 281),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161211, 141),
      ))
    }

@delegate:ResourceContentHash(-513_660_688)
public val Res.string.legal_terms: StringResource by lazy {
      StringResource("string:legal_terms", "legal_terms", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 177490, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 251582, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161413, 35),
      ))
    }

@delegate:ResourceContentHash(121_579_634)
public val Res.string.legal_terms_url: StringResource by lazy {
      StringResource("string:legal_terms_url", "legal_terms_url", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 177426, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 251518, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161353, 59),
      ))
    }

@delegate:ResourceContentHash(-1_514_996_358)
public val Res.string.limit_exceeds_days: StringResource by lazy {
      StringResource("string:limit_exceeds_days", "limit_exceeds_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 177613, 154),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 251777, 238),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161540, 146),
      ))
    }

@delegate:ResourceContentHash(1_725_892_457)
public val Res.string.limit_exceeds_days_for: StringResource by lazy {
      StringResource("string:limit_exceeds_days_for", "limit_exceeds_days_for", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 177522, 90),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 251650, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161449, 90),
      ))
    }

@delegate:ResourceContentHash(1_612_456_765)
public val Res.string.limit_exceeds_hours: StringResource by lazy {
      StringResource("string:limit_exceeds_hours", "limit_exceeds_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 177864, 163),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 252144, 243),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161783, 151),
      ))
    }

@delegate:ResourceContentHash(-1_738_128_634)
public val Res.string.limit_exceeds_hours_for: StringResource by lazy {
      StringResource("string:limit_exceeds_hours_for", "limit_exceeds_hours_for", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 177768, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 252016, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161687, 95),
      ))
    }

@delegate:ResourceContentHash(1_475_068_818)
public val Res.string.limit_exceeds_overtime: StringResource by lazy {
      StringResource("string:limit_exceeds_overtime", "limit_exceeds_overtime", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178028, 106),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 252388, 186),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161935, 114),
      ))
    }

@delegate:ResourceContentHash(614_151_364)
public val Res.string.limit_occasion_missing: StringResource by lazy {
      StringResource("string:limit_occasion_missing", "limit_occasion_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178135, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 252575, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162050, 58),
      ))
    }

@delegate:ResourceContentHash(1_385_100_894)
public val Res.string.limit_too_long: StringResource by lazy {
      StringResource("string:limit_too_long", "limit_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178198, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 252646, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162109, 58),
      ))
    }

@delegate:ResourceContentHash(875_709_631)
public val Res.string.limit_unit_days: StringResource by lazy {
      StringResource("string:limit_unit_days", "limit_unit_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178265, 115),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 252749, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162168, 95),
      ))
    }

@delegate:ResourceContentHash(1_061_665_147)
public val Res.string.line_accident: StringResource by lazy {
      StringResource("string:line_accident", "line_accident", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178381, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 252917, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162264, 33),
      ))
    }

@delegate:ResourceContentHash(-1_785_583_314)
public val Res.string.line_disability: StringResource by lazy {
      StringResource("string:line_disability", "line_disability", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178415, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 252995, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162298, 39),
      ))
    }

@delegate:ResourceContentHash(1_323_832_442)
public val Res.string.line_guarantee_fund: StringResource by lazy {
      StringResource("string:line_guarantee_fund", "line_guarantee_fund", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178451, 91),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 253079, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162338, 59),
      ))
    }

@delegate:ResourceContentHash(329_643_717)
public val Res.string.line_health: StringResource by lazy {
      StringResource("string:line_health", "line_health", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178543, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 253199, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162398, 43),
      ))
    }

@delegate:ResourceContentHash(570_837_581)
public val Res.string.line_income_tax: StringResource by lazy {
      StringResource("string:line_income_tax", "line_income_tax", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178575, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 253271, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162442, 47),
      ))
    }

@delegate:ResourceContentHash(333_200_994)
public val Res.string.line_labour_fund: StringResource by lazy {
      StringResource("string:line_labour_fund", "line_labour_fund", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178639, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 253383, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162490, 40),
      ))
    }

@delegate:ResourceContentHash(1_463_670_109)
public val Res.string.line_pension: StringResource by lazy {
      StringResource("string:line_pension", "line_pension", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178684, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 253436, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162531, 32),
      ))
    }

@delegate:ResourceContentHash(-1_711_551_685)
public val Res.string.line_ppk: StringResource by lazy {
      StringResource("string:line_ppk", "line_ppk", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178721, 20),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 253481, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162564, 20),
      ))
    }

@delegate:ResourceContentHash(-1_216_415_213)
public val Res.string.line_sickness: StringResource by lazy {
      StringResource("string:line_sickness", "line_sickness", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178742, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 253502, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162585, 33),
      ))
    }

@delegate:ResourceContentHash(155_879_836)
public val Res.string.loading: StringResource by lazy {
      StringResource("string:loading", "loading", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178776, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 253572, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162619, 31),
      ))
    }

@delegate:ResourceContentHash(-114_714_146)
public val Res.string.local_event_add: StringResource by lazy {
      StringResource("string:local_event_add", "local_event_add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178812, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 253624, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162651, 39),
      ))
    }

@delegate:ResourceContentHash(-1_570_251_210)
public val Res.string.local_event_also_in: StringResource by lazy {
      StringResource("string:local_event_also_in", "local_event_also_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178864, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 253684, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162691, 39),
      ))
    }

@delegate:ResourceContentHash(-1_020_130_421)
public val Res.string.local_event_edit_named: StringResource by lazy {
      StringResource("string:local_event_edit_named", "local_event_edit_named", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178916, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 253752, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162731, 54),
      ))
    }

@delegate:ResourceContentHash(-166_732_072)
public val Res.string.local_event_error_date: StringResource by lazy {
      StringResource("string:local_event_error_date", "local_event_error_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 178975, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 253827, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162786, 46),
      ))
    }

@delegate:ResourceContentHash(-1_150_663_931)
public val Res.string.local_event_error_long: StringResource by lazy {
      StringResource("string:local_event_error_long", "local_event_error_long", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 179022, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 253890, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162833, 50),
      ))
    }

@delegate:ResourceContentHash(977_644_751)
public val Res.string.local_event_error_name: StringResource by lazy {
      StringResource("string:local_event_error_name", "local_event_error_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 179141, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 254045, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162948, 46),
      ))
    }

@delegate:ResourceContentHash(142_445_967)
public val Res.string.local_event_error_name_long: StringResource by lazy {
      StringResource("string:local_event_error_name_long", "local_event_error_name_long", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 179077, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 253957, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162884, 63),
      ))
    }

@delegate:ResourceContentHash(1_190_175_017)
public val Res.string.local_event_error_order: StringResource by lazy {
      StringResource("string:local_event_error_order", "local_event_error_order", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 179188, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 254112, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162995, 67),
      ))
    }

@delegate:ResourceContentHash(453_375_469)
public val Res.string.local_event_from: StringResource by lazy {
      StringResource("string:local_event_from", "local_event_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 179260, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 254204, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163063, 32),
      ))
    }

@delegate:ResourceContentHash(1_524_709_883)
public val Res.string.local_event_name: StringResource by lazy {
      StringResource("string:local_event_name", "local_event_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 179355, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 254315, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163166, 32),
      ))
    }

@delegate:ResourceContentHash(1_366_127_047)
public val Res.string.local_event_name_hint: StringResource by lazy {
      StringResource("string:local_event_name_hint", "local_event_name_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 179289, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 254233, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163096, 69),
      ))
    }

@delegate:ResourceContentHash(-1_731_756_278)
public val Res.string.local_event_on_this_day: StringResource by lazy {
      StringResource("string:local_event_on_this_day", "local_event_on_this_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 179388, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 254356, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163199, 47),
      ))
    }

@delegate:ResourceContentHash(930_635_608)
public val Res.string.local_event_title_edit: StringResource by lazy {
      StringResource("string:local_event_title_edit", "local_event_title_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 179432, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 254412, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163247, 38),
      ))
    }

@delegate:ResourceContentHash(-780_540_543)
public val Res.string.local_event_title_new: StringResource by lazy {
      StringResource("string:local_event_title_new", "local_event_title_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 179479, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 254459, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163286, 41),
      ))
    }

@delegate:ResourceContentHash(1_349_960_520)
public val Res.string.local_event_to: StringResource by lazy {
      StringResource("string:local_event_to", "local_event_to", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 179529, 26),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 254517, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163328, 26),
      ))
    }

@delegate:ResourceContentHash(-1_503_061_089)
public val Res.string.local_event_yearly: StringResource by lazy {
      StringResource("string:local_event_yearly", "local_event_yearly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 179636, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 254656, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163435, 42),
      ))
    }

@delegate:ResourceContentHash(-1_212_694_049)
public val Res.string.local_event_yearly_hint: StringResource by lazy {
      StringResource("string:local_event_yearly_hint", "local_event_yearly_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 179556, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 254548, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163355, 79),
      ))
    }

@delegate:ResourceContentHash(1_690_575_165)
public val Res.string.location_notice_continue: StringResource by lazy {
      StringResource("string:location_notice_continue", "location_notice_continue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 179675, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 254699, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163478, 44),
      ))
    }

@delegate:ResourceContentHash(1_892_208_508)
public val Res.string.location_notice_text: StringResource by lazy {
      StringResource("string:location_notice_text", "location_notice_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 179716, 1000),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 254744, 1732),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163523, 928),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString21Resources(map: MutableMap<String, StringResource>) {
  map.put("labour_budget_open_unpriced", Res.string.labour_budget_open_unpriced)
  map.put("labour_budget_over", Res.string.labour_budget_over)
  map.put("labour_budget_planned", Res.string.labour_budget_planned)
  map.put("labour_budget_used", Res.string.labour_budget_used)
  map.put("labour_budget_week", Res.string.labour_budget_week)
  map.put("labour_cost_export", Res.string.labour_cost_export)
  map.put("labour_cost_exported", Res.string.labour_cost_exported)
  map.put("labour_warning_daily_norm", Res.string.labour_warning_daily_norm)
  map.put("labour_warning_daily_rest", Res.string.labour_warning_daily_rest)
  map.put("labour_warning_overtime", Res.string.labour_warning_overtime)
  map.put("labour_warning_weekly_average", Res.string.labour_warning_weekly_average)
  map.put("labour_warning_weekly_rest", Res.string.labour_warning_weekly_rest)
  map.put("language_change", Res.string.language_change)
  map.put("language_device", Res.string.language_device)
  map.put("language_device_current", Res.string.language_device_current)
  map.put("language_hint", Res.string.language_hint)
  map.put("language_name_en", Res.string.language_name_en)
  map.put("language_name_pl", Res.string.language_name_pl)
  map.put("language_name_uk", Res.string.language_name_uk)
  map.put("language_title", Res.string.language_title)
  map.put("leave_allowance_carry_over", Res.string.leave_allowance_carry_over)
  map.put("leave_allowance_entitlement", Res.string.leave_allowance_entitlement)
  map.put("leave_allowance_entitlement_hint", Res.string.leave_allowance_entitlement_hint)
  map.put("leave_allowance_entitlement_hint_unknown", Res.string.leave_allowance_entitlement_hint_unknown)
  map.put("leave_allowance_invalid", Res.string.leave_allowance_invalid)
  map.put("leave_allowance_saved", Res.string.leave_allowance_saved)
  map.put("leave_allowance_title", Res.string.leave_allowance_title)
  map.put("leave_balance_carry_over", Res.string.leave_balance_carry_over)
  map.put("leave_balance_entitlement", Res.string.leave_balance_entitlement)
  map.put("leave_balance_entitlement_set", Res.string.leave_balance_entitlement_set)
  map.put("leave_balance_left", Res.string.leave_balance_left)
  map.put("leave_balance_on_demand", Res.string.leave_balance_on_demand)
  map.put("leave_balance_pending", Res.string.leave_balance_pending)
  map.put("leave_balance_title", Res.string.leave_balance_title)
  map.put("leave_balance_unknown", Res.string.leave_balance_unknown)
  map.put("leave_balance_used", Res.string.leave_balance_used)
  map.put("leave_balances_edit", Res.string.leave_balances_edit)
  map.put("leave_balances_empty", Res.string.leave_balances_empty)
  map.put("leave_balances_export", Res.string.leave_balances_export)
  map.put("leave_balances_exported", Res.string.leave_balances_exported)
  map.put("leave_balances_open", Res.string.leave_balances_open)
  map.put("leave_balances_title", Res.string.leave_balances_title)
  map.put("leave_csv_carry_over", Res.string.leave_csv_carry_over)
  map.put("leave_csv_entitlement", Res.string.leave_csv_entitlement)
  map.put("leave_csv_on_demand_limit", Res.string.leave_csv_on_demand_limit)
  map.put("leave_csv_on_demand_used", Res.string.leave_csv_on_demand_used)
  map.put("leave_csv_pending", Res.string.leave_csv_pending)
  map.put("leave_csv_remaining", Res.string.leave_csv_remaining)
  map.put("leave_csv_total", Res.string.leave_csv_total)
  map.put("leave_csv_used", Res.string.leave_csv_used)
  map.put("leave_csv_year", Res.string.leave_csv_year)
  map.put("leave_request_days", Res.string.leave_request_days)
  map.put("leave_request_exceeds", Res.string.leave_request_exceeds)
  map.put("leave_request_exceeds_on_demand", Res.string.leave_request_exceeds_on_demand)
  map.put("ledger_kind_cost", Res.string.ledger_kind_cost)
  map.put("ledger_kind_label", Res.string.ledger_kind_label)
  map.put("ledger_kind_revenue", Res.string.ledger_kind_revenue)
  map.put("legal_dpa_note", Res.string.legal_dpa_note)
  map.put("legal_privacy", Res.string.legal_privacy)
  map.put("legal_privacy_url", Res.string.legal_privacy_url)
  map.put("legal_signup_note", Res.string.legal_signup_note)
  map.put("legal_terms", Res.string.legal_terms)
  map.put("legal_terms_url", Res.string.legal_terms_url)
  map.put("limit_exceeds_days", Res.string.limit_exceeds_days)
  map.put("limit_exceeds_days_for", Res.string.limit_exceeds_days_for)
  map.put("limit_exceeds_hours", Res.string.limit_exceeds_hours)
  map.put("limit_exceeds_hours_for", Res.string.limit_exceeds_hours_for)
  map.put("limit_exceeds_overtime", Res.string.limit_exceeds_overtime)
  map.put("limit_occasion_missing", Res.string.limit_occasion_missing)
  map.put("limit_too_long", Res.string.limit_too_long)
  map.put("limit_unit_days", Res.string.limit_unit_days)
  map.put("line_accident", Res.string.line_accident)
  map.put("line_disability", Res.string.line_disability)
  map.put("line_guarantee_fund", Res.string.line_guarantee_fund)
  map.put("line_health", Res.string.line_health)
  map.put("line_income_tax", Res.string.line_income_tax)
  map.put("line_labour_fund", Res.string.line_labour_fund)
  map.put("line_pension", Res.string.line_pension)
  map.put("line_ppk", Res.string.line_ppk)
  map.put("line_sickness", Res.string.line_sickness)
  map.put("loading", Res.string.loading)
  map.put("local_event_add", Res.string.local_event_add)
  map.put("local_event_also_in", Res.string.local_event_also_in)
  map.put("local_event_edit_named", Res.string.local_event_edit_named)
  map.put("local_event_error_date", Res.string.local_event_error_date)
  map.put("local_event_error_long", Res.string.local_event_error_long)
  map.put("local_event_error_name", Res.string.local_event_error_name)
  map.put("local_event_error_name_long", Res.string.local_event_error_name_long)
  map.put("local_event_error_order", Res.string.local_event_error_order)
  map.put("local_event_from", Res.string.local_event_from)
  map.put("local_event_name", Res.string.local_event_name)
  map.put("local_event_name_hint", Res.string.local_event_name_hint)
  map.put("local_event_on_this_day", Res.string.local_event_on_this_day)
  map.put("local_event_title_edit", Res.string.local_event_title_edit)
  map.put("local_event_title_new", Res.string.local_event_title_new)
  map.put("local_event_to", Res.string.local_event_to)
  map.put("local_event_yearly", Res.string.local_event_yearly)
  map.put("local_event_yearly_hint", Res.string.local_event_yearly_hint)
  map.put("location_notice_continue", Res.string.location_notice_continue)
  map.put("location_notice_text", Res.string.location_notice_text)
}
